import SiteHeader from "@/pages/home/components/SiteHeader";
import Hero from "@/pages/home/components/Hero";
import OverviewSection from "@/pages/home/components/OverviewSection";
import PlotSection from "@/pages/home/components/PlotSection";
import CastSection from "@/pages/home/components/CastSection";
import QualitySection from "@/pages/home/components/QualitySection";
import LinesSection from "@/pages/home/components/LinesSection";
import DownloadSection from "@/pages/home/components/DownloadSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import FaqSection from "@/pages/home/components/FaqSection";
import RelatedSection from "@/pages/home/components/RelatedSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <SiteHeader />
      <main>
        <Hero />
        <OverviewSection />
        <PlotSection />
        <CastSection />
        <QualitySection />
        <LinesSection />
        <DownloadSection />
        <TimelineSection />
        <FaqSection />
        <RelatedSection />
      </main>
      <SiteFooter />
    </div>
  );
}